import PropTypes from 'prop-types';
import {Translate, I18n} from 'react-redux-i18n';
import {EntityIllustration} from 'front-onceforall-core';
import moment from 'moment-timezone';

import {getOrganisationLogoUrl} from '../../../utils/organisation';
import {status} from '../../../utils/constant';
import DatetimeFormat from '../../datetime/DatetimeFormat';
import ResendButton from '../../notification/ResendButton';
import ClonedInvitationTooltip from '../../ClonedInvitationTooltip';

import ResendReasonPanel from './ResendReasonPanel';
import DownloadAccessCode from './DownloadAccessCode';
import Cancel from './Cancel';

function InvitationView(props) {
  const {invitation} = props;
  const {
    country,
    registrationNumber,
    organisationName,
    userFullname,
    organisationId,
    email,
    creationDate
  } = invitation;

  const isRejected = invitation.status === status.REJECTED;
  let fullName = organisationName || userFullname;
  if (!fullName) {
    if (props.isSubcontractorView) {
      fullName = invitation.subcontractor.fullName;
    } else {
      fullName = invitation.client.fullName;
    }
  }
  const imageUrl = getOrganisationLogoUrl(organisationId);

  function getRejectionReason(rejectionReason) {
    return (
      <>
        <Translate value="rejectionReason.displayLabel"/>
        {rejectionReason ?
          <Translate value={`rejectionReason.reason.${rejectionReason.toUpperCase()}`}/> :
          <Translate value={'rejectionReason.reason.NO_REASON_GIVEN'}/>
        }
      </>
    );
  }

  function getStatus() {
    if (isRejected) {
      return getRejectionReason(invitation.rejectionReason);
    }

    if (invitation.relationshipId) {
      return <Translate value="invitation.sent.waitingForApproval"/>;
    }

    if (invitation.invitationId) {
      return <Translate
        value={`invitation.sent.waitingForRegistration.${props.isSubcontractorView ? 'subcontractor' : 'client'}`}
      />;
    }

    return null;
  }

  function getRensentDate() {
    if (!isRejected && invitation.lastSentDate && !moment(invitation.creationDate).isSame(invitation.lastSentDate, 'days')) {
      return <Translate
        value="invitation.sent.resentOn"
        date={I18n.l(invitation.lastSentDate, {dateFormat: 'datetime.shortDate'})}
      />;
    }

    return null;
  }

  return (
    <tr className={isRejected ? 'disabled' : ''}>
      <td>
        <div className="two-lines">
          <div className="inline-container">
            <EntityIllustration
              country={country}
              name={fullName}
              imageUrl={imageUrl}
              small
            />
            <div className="ml-2 inline-container column">
              <div>
                <span data-id="organisationName">{fullName}</span>
                <ClonedInvitationTooltip invitation={invitation}/>
              </div>
              <span
                data-id="registrationNumber"
                className="information"
              >
                {registrationNumber}
              </span>
            </div>
          </div>
        </div>
      </td>
      <td><span data-id="email">{email}</span></td>
      <td>
        <span data-id="creationDate">
          <DatetimeFormat
            value={creationDate}
            format="shortDate"
          />
        </span>
      </td>
      <td>
        <div>{getStatus()}</div>
        <div>{getRensentDate()}</div>
      </td>
      <td>
        <div className="inline-container flex-end">
          {!invitation.accessCode &&
            <ResendButton
              invitation={invitation}
              onResendInvitation={props.onResendInvitation}
              loading={props.loading}
            />
          }
          <ResendReasonPanel
            onClose={props.onClosePanel}
            isOpen={props.isPanelOpen}
            onSubmit={props.onSubmitReason}
          />
          <DownloadAccessCode invitation={invitation}/>
          <Cancel
            invitation={invitation}
            isSubcontractorView={props.isSubcontractorView}
            onCancelSuccess={props.onCancelSuccess}
          />
        </div>
      </td>
    </tr>
  );
}

InvitationView.propTypes = {
  invitation: PropTypes.object.isRequired,
  onResendInvitation: PropTypes.func.isRequired,
  onCancelSuccess: PropTypes.func.isRequired,
  isSubcontractorView: PropTypes.bool,
  isPanelOpen: PropTypes.bool.isRequired,
  onClosePanel: PropTypes.func.isRequired,
  onSubmitReason: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default InvitationView;
